import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Classes, Menu, MenuDivider } from '@blueprintjs/core';
import Pages from './Pages';

export default class SideMenuRight extends Component {
  render() {
    return (
      <Menu className={Classes.ELEVATION_1}>
        <MenuDivider title="Filter Settings" />

        {Pages.FilterSettings.sort((x, y) =>
          x.Name.toLowerCase() > y.Name.toLowerCase() ? 1 : -1
        )
          .slice(21)
          .map((Link, LinkIndex) => (
            <li key={LinkIndex}>
              <NavLink
                className={`bp3-menu-item bp3-icon-${Link.Icon}`}
                to={Link.To}
                disabled={Link.Disabled}
              >
                {Link.Name}
              </NavLink>
            </li>
          ))}

        <MenuDivider title="Web Settings" />

        {Pages.WebSettings.map((Link, LinkIndex) => (
          <li key={LinkIndex}>
            <NavLink
              className={`bp3-menu-item bp3-icon-${Link.Icon}`}
              to={Link.To}
              disabled={Link.Disabled}
            >
              {Link.Name}
            </NavLink>
          </li>
        ))}

        <MenuDivider title="Server Settings" />

        {Pages.ServerSettings.map((Link, LinkIndex) => (
          <li key={LinkIndex}>
            <NavLink
              className={`bp3-menu-item bp3-icon-${Link.Icon}`}
              to={Link.To}
              disabled={Link.Disabled}
            >
              {Link.Name}
            </NavLink>
          </li>
        ))}
      </Menu>
    );
  }
}
